module.exports = ".banner {\n  width: 1600px;\n  height: 400; }\n\nimg {\n  display: block;\n  max-width: 100%;\n  max-height: 300px;\n  -o-object-fit: contain;\n     object-fit: contain;\n  background-color: #f0f0f0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master-shared/master-slider/master-slider.component.scss
// module id = ./src/app/master-shared/master-slider/master-slider.component.scss
// module chunks = main